export default {"src":"/org/_next/static/media/clock.644ad0b1.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};